import { mdiClipboardArrowUpOutline, mdiClose } from '@mdi/js';
import copy from 'copy-text-to-clipboard';
import _ from 'lodash';
import React, { useContext } from 'react';
import { ToastContext } from '../../services';
import * as S from './action-badge.styles';

export interface IActionBadgeProps {
    className?: string;
    children?: React.ReactNode;
    path?: string;
    tooltip?: string | React.ReactElement;
    hideAction?: boolean;
    onCopy?: (url: string) => void;
    onRemove?: () => void;
    removeLabel?: string;
    openInNewTab?: boolean;
    Symbol?: React.ReactNode;
}

export const ActionBadge: React.FunctionComponent<IActionBadgeProps> = (
    props: IActionBadgeProps,
): React.ReactElement => {
    const {
        className,
        children,
        path,
        tooltip,
        hideAction,
        onCopy,
        onRemove,
        removeLabel,
        openInNewTab,
        Symbol,
    } = props;

    const context = useContext(ToastContext);
    const actionIcon = onRemove ? mdiClose : mdiClipboardArrowUpOutline;
    const renderTooltipTitle = (): React.ReactElement => {
        if (_.isString(tooltip)) {
            return <span>{tooltip}</span>;
        } else if (tooltip) {
            return tooltip;
        } else {
            return <></>;
        }
    };
    const renderActionTitle = (): React.ReactElement => {
        if (onRemove) {
            return <span>{removeLabel || 'Remove'}</span>;
        } else {
            return <span>Copy URL</span>;
        }
    };
    const handleAction = (): void => {
        if (onRemove) {
            onRemove();
        } else {
            const url = `${window.location.origin}${path}`;
            copy(url);
            onCopy && onCopy(url);
            context.notify && context.notify('URL copied to clipboard', 'left');
        }
    };

    return (
        <S.Badge className={className}>
            <S.VisitLink href={path || '/'} target={openInNewTab ? '_blank' : undefined}>
                <S.VisitTooltip direction="top" variant="dark" title={renderTooltipTitle()}>
                    {Symbol && <S.ActionSymbol>{Symbol}</S.ActionSymbol>}
                    {children}
                </S.VisitTooltip>
            </S.VisitLink>
            {!hideAction && (
                <S.ActionButton onClick={handleAction}>
                    <S.ActionTooltip direction="top" variant="dark" title={renderActionTitle()}>
                        <S.ActionIcon path={actionIcon} size={0.75} />
                    </S.ActionTooltip>
                </S.ActionButton>
            )}
        </S.Badge>
    );
};
